module.exports = __webpack_public_path__ + "assets/img/3.07a80c0b.png";